/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CostConfigDto } from './costConfigDto';

export interface EmployeeIdDto {
  active?: boolean;
  costConfig?: CostConfigDto;
  deleted?: boolean;
  email?: string;
  employeeId?: number;
  employerUsername?: string;
  firstName?: string;
  lastName?: string;
  username?: string;
}
